<template>
  <div>
        <template v-if="$route.name === 'classes.index'">

    <ChapterSubjectFilters
      @status="handleStatusFilter"
      @chapter="handleChapterFilter"
      @subject="handleSubjectFilter"
      @add="navigateToAdd"
      @reset="resetFilters"
    />

    <ChapterSubjectTable
      :chapter-subjects="chapterSubjects.data"
      :loading="isLoading"
      @delete-chapter-subject="openDeleteDialog"
    />

    <PaginationControls
      v-if="pagination.totalItems > 10"
      :pagination="pagination"
      @page-changed="changePage"
      class="mt-4 mb-5"
    />

    <DeleteDialog ref="deleteDialog" @delete="deleteChapterSubject" />
    </template>
        <router-view></router-view>

  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import ChapterSubjectTable from "@/components/features/chapter-subject/ChapterSubjectTable.vue";
import ChapterSubjectFilters from "@/components/features/chapter-subject/ChapterSubjectFilter.vue";
import DeleteDialog from "@/components/features/chapter-subject/dialogs/DeleteDialog.vue";
import PaginationControls from "@/components/common/PaginationControls.vue";
import api from "@/api";

const router = useRouter();
const toast = useToast();
const deleteDialog = ref(null);

const chapterSubjects = ref({ data: [] });
const isLoading = ref(false);
const statusFilter = ref("");
const chapterFilter = ref("");
const subjectFilter = ref("");
const pagination = ref({
  currentPage: 1,
  totalPages: 1,
  totalItems: 0,
  perPage: 10,
  from: 0,
  to: 0,
});

const fetchChapterSubjects = async (page = 1) => {
  isLoading.value = true;
  try {
    const response = await api.get("/chapter-subjects", {
      params: {
        page,
        status: statusFilter.value,
        chapter_id: chapterFilter.value,
        subject_id: subjectFilter.value,
      },
    });
    chapterSubjects.value = response.data;
    updatePagination(response.data.meta);
  } catch (error) {
    toast.error("فشل في تحميل روابط الفصول والمواد");
    console.error("Error fetching chapter subjects:", error);
  } finally {
    isLoading.value = false;
  }
};

const updatePagination = (meta) => {
  pagination.value = {
    currentPage: meta.current_page,
    totalPages: meta.last_page,
    totalItems: meta.total,
    perPage: meta.per_page,
    from: meta.from,
    to: meta.to,
  };
};

const handleStatusFilter = (status) => {
  statusFilter.value = status;
  fetchChapterSubjects(1);
};

const handleChapterFilter = (chapterId) => {
  chapterFilter.value = chapterId;
  fetchChapterSubjects(1);
};

const handleSubjectFilter = (subjectId) => {
  subjectFilter.value = subjectId;
  fetchChapterSubjects(1);
};

const resetFilters = () => {
  statusFilter.value = "";
  chapterFilter.value = "";
  subjectFilter.value = "";
  fetchChapterSubjects(1);
};

const changePage = (page) => {
  fetchChapterSubjects(page);
};

const openDeleteDialog = (chapterSubject) => {
  deleteDialog.value?.open({
    id: chapterSubject.id,
    name: `${chapterSubject.chapter?.name} - ${chapterSubject.subject?.name}`,
  });
};

const deleteChapterSubject = async (id) => {
  try {
    await api.delete(`/chapter-subjects/${id}`);
    toast.success("تم حذف الرابط بنجاح");
    fetchChapterSubjects(pagination.value.currentPage);
  } catch (error) {
    toast.error("فشل في حذف الرابط");
    console.error("Error deleting chapter subject:", error);
  }
};

const navigateToAdd = () => {
  router.push({ name: "chapter-subjects.create" });
};

onMounted(() => {
  fetchChapterSubjects();
});
</script>
